var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSec1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 63.6716,
    width: 90.0453,
    height: 90.0453,
    rx: 37,
    transform: "rotate(-45 0 63.6716)",
    fill: "#000466",
    fillOpacity: 0.69
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_154_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4101 43.7127C75.314 43.0868 75.0619 42.4951 74.6774 41.9928C74.293 41.4906 73.7886 41.0942 73.2114 40.8406L45.796 31.0186L44.3078 23.8897C43.8746 22.4965 42.9418 21.3142 41.6912 20.5732C40.4407 19.8323 38.9619 19.5859 37.5434 19.882C36.1249 20.1782 34.8684 20.9956 34.0187 22.175C33.169 23.3544 32.7871 24.8112 32.9476 26.2613L43.8432 78.4513C43.9332 79.2647 44.1912 80.0506 44.6006 80.7585C45.01 81.4665 45.5617 82.0809 46.2204 82.5623C46.8791 83.0437 47.6302 83.3815 48.4254 83.5539C49.2207 83.7263 50.0425 83.7295 50.8381 83.5634C51.6337 83.3973 52.3856 83.0655 53.0455 82.5894C53.7053 82.1132 54.2585 81.5031 54.6696 80.7984C55.0806 80.0937 55.3405 79.3098 55.4324 78.4972C55.5244 77.6846 55.4463 76.8611 55.2034 76.0797L52.8043 64.5883L74.3134 47.4394C74.8128 46.976 75.1784 46.3852 75.3714 45.7292C75.5644 45.0733 75.5778 44.3766 75.4101 43.7127ZM47.6175 39.7435L64.3003 45.699L51.0717 56.289L47.6175 39.7435Z",
    fill: "#C48C2D"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_154_11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.741 75.7947C110.068 73.9745 108.37 73.198 106.165 73.7106L79.896 81.2892L81.2819 76.1691C81.7023 76.1427 82.117 76.0594 82.5148 75.9216L105.077 69.5062C105.519 69.3423 105.925 69.0929 106.27 68.7721C106.615 68.4513 106.892 68.0655 107.087 67.637C107.282 67.2085 107.39 66.7456 107.405 66.2751C107.419 65.8046 107.341 65.3356 107.173 64.8953C106.513 63.0259 104.816 62.2493 102.597 62.8112L83.4275 68.2428L84.8534 62.9751C85.2316 61.578 85.0377 60.0874 84.3143 58.8313C83.591 57.5752 82.3975 56.6565 80.9963 56.2772C79.5906 55.8967 78.0919 56.0849 76.8263 56.8011C75.5606 57.5173 74.6304 58.7035 74.238 60.1016L61.1648 108.398C60.9758 109.096 60.9266 109.825 61.0199 110.542C61.1133 111.26 61.3474 111.952 61.7089 112.58C62.0704 113.208 62.5522 113.759 63.1269 114.201C63.7015 114.643 64.3577 114.969 65.0579 115.158C65.7559 115.347 66.4842 115.396 67.2009 115.303C67.9176 115.209 68.6085 114.975 69.2335 114.614C69.8585 114.252 70.4054 113.771 70.8425 113.197C71.2797 112.624 71.5983 111.969 71.7802 111.271L77.7504 89.2155C78.1708 89.189 78.5855 89.1058 78.9833 88.968L108.645 80.4056C109.091 80.2476 109.501 80.0015 109.85 79.6819C110.199 79.3623 110.479 78.9758 110.675 78.5455C110.87 78.1152 110.977 77.6498 110.988 77.1772C111 76.7046 110.915 76.2344 110.741 75.7947Z",
    fill: "#C48C2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_154_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 65,
    fill: "white",
    transform: "translate(31.7592 20.5688) rotate(-11.7922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_154_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 61,
    fill: "white",
    transform: "translate(75.6639 54.8337) rotate(15.1463)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1);
export default __webpack_public_path__ + "static/media/sec1.8c64f80c808dad11f77480bc524f15e8.svg";
export { ForwardRef as ReactComponent };